import React,{useState,useEffect} from 'react'
import './PricingComponent.css'
import { invokeTermDates,invokeSquadInfo, invokeDisclaimer } from '../ServiceCalls/ApiCalls'

function PricingComponent() {

  const[termdates,setTermDates] = useState([])
  const[squadinfo,setSquadInfo] = useState([])
  const[disclaimer,setDisclaimer] = useState([])

  useEffect(() =>{

    async function fetchData(){
        const term_dates_list = await invokeTermDates()
        setTermDates([...term_dates_list])

        const squadinfo_list = await invokeSquadInfo();
        setSquadInfo(squadinfo_list)

        const disclaimer_list = await invokeDisclaimer();
        setDisclaimer([...disclaimer_list])

    }

    fetchData()
  },[])
  return (
    <>
          <section id="pricing">
              <div class="container">
                  <div class="section-header">
                      <h2 class="section-title wow fadeInDown">Squad Training</h2>
                      <p class="wow fadeInDown">The Beginner/Intermediate stream, and the Elite stream sessions run every week throughout the term, breaking for school holidays. To join any sessions simply show up for a no obligation free trial.</p>
                  </div>
                  <div class="row d-flex justify-content-center">
                     {
                        termdates.map((term,idx) =>{
                            return  <div class="col-md-3 col-sm-6 col-xs-12 term-card">
                                        <p class="term-head text-center fw-bold text-uppercase">{term.term_name}</p>
                                        <p class="term-body text-center text-center">{term.term_period}</p>
                                        <p class="term-year text-center small">{term.term_year}</p>
                                    </div>
                        })
                     }
                    
                  </div>
                  <div class="row d-flex justify-content-center">
                     {
                        squadinfo.map((s,idx) => <div class="col-md-3 col-sm-6 col-xs-12" key={idx}>
                            <div class="wow zoomIn" data-wow-duration="400ms" data-wow-delay="0ms">
                                <ul class="pricing">
                                    <li class="plan-header">
                                        <div class="price-duration">
                                            <span class="price">
                                                ${s.squad_cost}
                                            </span>
                                            <span class="duration">
                                                per Term
                                            </span>
                                        </div>
                                        <div class="plan-name">
                                                {s.squad_name}
                                        </div>
                                        <span class="price-ribbon">Only - {s.day}</span>
                                            <p>{s.timing}</p>
                                    </li>
                                    {/* <li><strong>Annual Membership $50</strong></li>
                                    <li class="plan-purchase"><a class="btn btn-primary" href="#">Get It Now!</a></li> */}
                                </ul>
                        </div>
                    </div>

                        
                        )
                    }
                  </div>
                  <div className='row mb-2'>
                        <div className='col-md-12 col-sm-12 squad-register'>
                                <a href="https://forms.gle/MvJnur2CtNArhYrP8" className='text-danger text-center' target='_blank'>Click Here For Registrations</a>
                        </div>
                  </div>
                  <div className="row">
                    <div className="disclaimer text-center p-3 my-2">
                        {
                            disclaimer.length > 0 ?
                            disclaimer.map((d,idx) =>{
                                return <ul>
                                    <li key={idx}>
                                        <span>
                                            {d.disclaimer}
                                        </span>
                                    </li>
                                </ul>
                            })
                            :
                            null
                        }
                        
                    </div>
                  </div>
              </div>
          </section>
    </>
  )
}

export default PricingComponent